import { Link } from "react-router-dom";

export default function Privacy() {
  const updated = "8 februari 2026";

  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="privacy-page">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-10">
        <div className="mx-auto max-w-4xl px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-home-link">
            <span className="h-7 w-7 rounded bg-brand flex items-center justify-center font-heading text-xs font-bold text-white">
              T
            </span>
            <span className="font-heading text-base text-slate-900">Tidsrapporten</span>
          </Link>
          <Link
            to="/data-deletion"
            className="text-sm text-brand hover:underline"
            data-testid="privacy-to-deletion-link"
          >
            Radera mina data →
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900">
          Integritetspolicy
        </h1>
        <p className="mt-3 text-sm text-slate-500" data-testid="privacy-updated">
          Senast uppdaterad: {updated}
        </p>

        <section className="mt-10 space-y-6 text-base leading-relaxed">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">1. Personuppgiftsansvarig</h2>
            <p className="mt-2">
              Tidsrapporten (”vi”, ”oss”) drivs av Trappkonsulten. Vi är personuppgiftsansvariga
              för de uppgifter som behandlas via tjänsten på{" "}
              <span className="font-mono">app.trappkonsulten.se</span>. Kontakt:{" "}
              <a href="mailto:paul@trappkonsulten.se" className="text-brand hover:underline">
                paul@trappkonsulten.se
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">2. Vilka uppgifter vi samlar in</h2>
            <ul className="mt-2 list-disc pl-6 space-y-1">
              <li>Kontouppgifter: namn, e-post, telefon, företagsnamn, organisationsnummer.</li>
              <li>Tidrapporter, objekt-, kund- och personalliggardata som du själv registrerar.</li>
              <li>Filuppladdningar (foton, PDF:er) kopplade till dina objekt.</li>
              <li>Tekniska loggar: IP-adress, webbläsare, tidsstämplar för säkerhet och drift.</li>
              <li>
                För marknadsföringsintegrationer (Meta/Instagram): endast{" "}
                <em>vår egen</em> sidas åtkomsttoken – vi läser aldrig dina personliga
                Facebook-/Instagramkonton.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">3. Ändamål och rättslig grund</h2>
            <ul className="mt-2 list-disc pl-6 space-y-1">
              <li>Leverera tjänsten enligt avtal (art. 6.1.b GDPR).</li>
              <li>Fullgöra bokförings- och skattelagstiftning, t.ex. Personalliggare (art. 6.1.c).</li>
              <li>Berättigat intresse för produktförbättring och säkerhet (art. 6.1.f).</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">4. Delning med underleverantörer</h2>
            <p className="mt-2">
              Vi delar uppgifter endast med personuppgiftsbiträden som behövs för driften:
              MongoDB Atlas (databas, EU), Cloudflare R2 (filbackuper), Resend (e-post),
              Stripe (betalning) och Meta Platforms (endast vår egen publiceringsintegration).
              Alla har DPA/GDPR-kompatibla avtal.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">5. Lagringstid</h2>
            <p className="mt-2">
              Aktiva kontodata sparas så länge kontot är aktivt. Bokförings­material sparas i minst
              7 år enligt bokföringslagen. Personalliggardata sparas i 2 år enligt Skatteverkets
              regler. Övrigt raderas eller anonymiseras när ändamålet upphör.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">6. Dina rättigheter</h2>
            <p className="mt-2">
              Du har rätt till registerutdrag, rättelse, radering, begränsning, invändning och
              dataportabilitet. Skicka begäran till{" "}
              <a href="mailto:paul@trappkonsulten.se" className="text-brand hover:underline">
                paul@trappkonsulten.se
              </a>{" "}
              eller använd vår <Link to="/data-deletion" className="text-brand hover:underline">
                självbetjänings­sida för radering
              </Link>
              . Klagomål lämnas till Integritetsskyddsmyndigheten (IMY).
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">7. Cookies</h2>
            <p className="mt-2">
              Vi använder endast nödvändiga cookies för inloggning och sessionshantering.
              Inga tredjeparts spårningscookies utan samtycke.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">8. Meta/Instagram-integration</h2>
            <p className="mt-2">
              När vi publicerar innehåll åt oss själva via Meta Graph API sker inget läs- eller
              skrivåtkomst till våra användares privata Meta-konton. Ingen kunddata överförs till
              Meta. För radering av data hänvisar Meta hit:{" "}
              <Link to="/data-deletion" className="text-brand hover:underline">
                /data-deletion
              </Link>
              .
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">9. Kontakt</h2>
            <p className="mt-2">
              Frågor? Mejla{" "}
              <a href="mailto:paul@trappkonsulten.se" className="text-brand hover:underline">
                paul@trappkonsulten.se
              </a>
              .
            </p>
          </div>
        </section>
      </main>

      <footer className="border-t border-slate-200 mt-16">
        <div className="mx-auto max-w-4xl px-6 py-6 text-xs text-slate-500 flex justify-between">
          <span>© {new Date().getFullYear()} Tidsrapporten</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-slate-900">Integritetspolicy</Link>
            <Link to="/data-deletion" className="hover:text-slate-900">Data­radering</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
